export const heroData = {
  title: "Cabin Baggage Restrictions",
  subtitle: "Please review our baggage guidelines to ensure a safe and comfortable flight.",
  image:
    "https://readdy.ai/api/search-image?query=Luxury%20helicopter%20cabin%20interior%20with%20leather%20seats%20and%20panoramic%20window%2C%20clean%20minimal%20interior%20design%2C%20soft%20warm%20lighting%2C%20dark%20navy%20sky%20outside%2C%20aviation%20safety%20atmosphere%2C%20editorial%20photography%2C%20no%20text&width=1920&height=600&seq=baghero01&orientation=landscape",
};

export const allowedData = {
  label: "ALLOWED",
  title: "What You Can Bring",
  items: [
    { name: "Smartphone", desc: "Photos and social media posts are welcome (watch for vibration inside the cabin)" },
    { name: "Camera", desc: "Small cameras are permitted" },
    { name: "Wallet & small items", desc: "Pocket-sized items are fine" },
    { name: "Sunglasses", desc: "Recommended for daytime tours" },
    { name: "Jacket or cardigan", desc: "Something you can layer at the helipad or in the cabin" },
    { name: "Medication", desc: "Please bring any medication you require" },
  ],
};

export const prohibitedData = {
  label: "PROHIBITED",
  title: "What You Cannot Bring",
  items: [
    { name: "Tripods & selfie sticks", desc: "Prohibited inside the cabin due to safety risks" },
    { name: "Bags & backpacks", desc: "Not permitted in the cabin — will be held at check-in" },
    { name: "Food & beverages", desc: "Eating and drinking in the cabin is not allowed (drinks provided by the operator)" },
    { name: "Hazardous & flammable items", desc: "Lighters, matches, and spray cans are prohibited" },
    { name: "Umbrellas (full-size)", desc: "Compact folding umbrellas are OK; full-size umbrellas are not permitted" },
    { name: "Pets", desc: "We are unable to accommodate pets" },
  ],
};

export const tipsData = {
  label: "TIPS",
  title: "Baggage Tips",
  items: [
    "Keep valuables on your person at all times. You are responsible for any items left in storage.",
    "Using a wrist strap for your smartphone helps prevent accidental drops.",
    "Hats are not recommended as they may be blown off by the wind.",
    "The helipad is outdoors — please dress and pack appropriately for the season.",
    "The cabin is relatively quiet, but you may bring ear protection if you prefer.",
  ],
};
